import React from 'react';
import { Button, Col, Drawer, DrawerProps, Row } from 'antd';
import { CloseOutlined, SaveOutlined } from '@ant-design/icons';
import { Label, SecondaryButton } from 'components/common';
import { SmartSpace } from 'components/Sales/Smart/SmartComponent';
import RecvItemList from './RecvItemList';

type Props = ReduxStateProps & DrawerProps & {
  onSave?: Function;
};

const RecvConfirmDrawer = (props: Props) => {
  const onClose = (evt: any) => {
    if (props.onClose) props.onClose(evt);
  };

  const onSave = (evt: any) => {
    if (props.onSave) props.onSave();
    onClose(evt);
  };

  const drawerFooter = () => {
    return (
      <Row>
        <Col span={12} style={{paddingRight: 5}}>
          <SecondaryButton
            onClick={onClose}
            size="large"
            style={{width: '100%'}}
          >
            <CloseOutlined />
            Cancel
          </SecondaryButton>
        </Col>
        <Col span={12} style={{paddingLeft: 5}}>
          <Button
            onClick={onSave}
            size="large"
            style={{width: '100%'}}
            type="primary"
          >
            <SaveOutlined />
            Save
          </Button>
        </Col>
      </Row>
    );
  };

  return (<>
    <Drawer
      bodyStyle={{ padding: 10 }}
      closable={false}
      footer={drawerFooter()}
      footerStyle={{ padding: 10 }}
      onClose={onClose}
      placement="bottom"
      visible={props.visible}
      width={window.innerWidth}
      height={window.innerHeight - 56}
    >
      <SmartSpace>
        <Row>
          <Label theme={{fontSize: '1.3em'}}>Receiving Lines</Label>
        </Row>
        <RecvItemList
          dispatch={props.dispatch}
          //editable={currentStep === RecvStep.ScanItem}
          state={props.state}
        />
      </SmartSpace>
    </Drawer>
  </>);
};

export default RecvConfirmDrawer;
